<template>
  <div id="engine-display-condition">
    <div class="engine-input-period-origin-items-wrapper flex flex-wrap">
      <div id="engine-input-period">
        <vs-row class="flex justify-start condition-header-row">
          <vs-col
            class="flex justify-start items-start condition-header-col-title"
          >
            <v-select
              :options="
                vesselMonitoringEngineList.map((engine) => ({
                  id: engine.enterprise_vessel_id,
                  name: engine.name_ja || engine.name,
                }))
              "
              :value="
                vesselMonitoringEngine.name_ja || vesselMonitoringEngine.name
              "
              :reduce="(options) => options.id"
              :getOptionKey="(option) => option.id"
              @input="
                (enterpriseVesselId) =>
                  handleChangeVesselName(enterpriseVesselId)
              "
              label="name"
              :searchable="false"
              placeholder="船名"
              :clearable="false"
              class="vessel-name-select-box aisea-text-18-600-dark-gray"
              color="#2D9CDB"
            ></v-select>
          </vs-col>
        </vs-row>
      </div>

      <!-- データ発生元一覧＋カスタムレポート -->
      <template v-if="channelOriginList.length > 0">
        <div id="engine-origin-items">
          <vs-tabs
            v-model="activeChannelOriginIndex"
            alignment="left"
            color="AISEA_COLOR.BLUE_GRAY"
          >
            <vs-tab
              v-for="origin in channelOriginList"
              :key="origin.id"
              :label="origin.name_loc || origin.name"
              @click="channelOriginClicked(origin.id)"
              class="ml-6 aisea-text-14-400-dark-gray"
              :icon="origin.icon"
            />
          </vs-tabs>
        </div>
      </template>
    </div>
    <template v-if="channelOriginList.length > 0">
      <div
        class="
          engine-category-voyage-period-wrapper
          flex
          items-baseline
          flex-wrap
          justify-between
        "
      >
        <div id="engine-category-items">
          <div class="channel-group-area">
            <div v-if="selectedChannelOriginId === 'custom'">
              <!-- カスタムレポート検索窓 -->
              <input-search-custom-report
                @refreshChannelData="refreshChannelDataFromCustom"
              />
            </div>

            <div v-else class="categories-area">
              <div
                class="category-select-box-wrapper"
                v-if="channelGroupList.length > 0"
              >
                <v-select
                  :options="
                    channelGroupList.map((group) => ({
                      id: group.channelGroup.channel_group_id,
                      name:
                        group.channelGroup.name_loc || group.channelGroup.name,
                    }))
                  "
                  :value="activeChannelGroupName"
                  :reduce="(options) => options.id"
                  :getOptionKey="(option) => option.id"
                  @input="(id) => channelGroupClicked(id)"
                  label="name"
                  :searchable="false"
                  placeholder=""
                  :clearable="false"
                  class="category-select-box aisea-text-16-400-black h-12"
                  color="#2D9CDB"
                ></v-select>
              </div>
            </div>
          </div>
        </div>
        <!-- リアルタイム・期間指定切り替え -->
        <div
          id="select-display-mode"
          class="flex justify-center items-center"
        >
          <div
            class="list-type-button live mr-2 cursor-pointer flex-shrink-0"
            :class="[
              isLiveMode
                ? 'list-type-button--selected'
                : 'list-type-button--default',
            ]"
            @click="handleClickLiveMode"
          >
            リアルタイム
          </div>
          <div
            class="list-type-button date ml-2 cursor-pointer flex-shrink-0"
            :class="[
              !isLiveMode
                ? 'list-type-button--selected'
                : 'list-type-button--default',
            ]"
            @click="handleClickDateMode"
          >
            期間指定
          </div>
        </div>
        <!-- 期間指定部分 -->
        <div
          class="
            voyage-period
            flex
            items-center
            period-info
            pt-5
            pb-3
            justify-start
          "
        >
          <span class="period-body aisea-text-16-400-black" v-if="isLiveMode">
            <div
              class="
                last-updated-at-wrapper
                flex flex-no-wrap flex-shrink-0
                items-center
                gap-1
                mr-auto
              "
            >
              <div
                class="
                  last-updated-at
                  flex flex-no-wrap flex-shrink-0
                  items-center
                  gap-1
                "
              >
                <vs-icon icon="schedule" size="15px"></vs-icon>
                <span class="aisea-text-14-300-black flex-shrink-0">
                  {{ "現在のデータを表示しています。" }}
                </span>
              </div>
            </div>
          </span>
          <!-- 行 -->
          <div v-else class="data row aisea-text-14-400-black">
            <input-period-form :applyCallBack="applyDateFromCalendar" />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from "moment"
import {createNamespacedHelpers} from "vuex"
import DatepickerMixin from "@/mixins/DatepickerMixin"
import InputSearchCustomReport from "./InputSearchCustomReport";
import InputPeriodForm from "./InputPeriodForm.vue";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import vSelect from "vue-select";
import { cloneDeep } from "lodash";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const EnterpriseVesselApi = AiseaApiFactory.get("enterpriseVessel");
const epVesselDisplayChannelApi = AiseaApiFactory.get(
  "enterpriseVesselDisplayChannel",
);
const { mapGetters, mapActions, mapState } = createNamespacedHelpers("enterpriseVesselMonitoringEngine")

export default {
  name: "inputDisplayCondition",
  props: ["deviceType"],
  components: {
    InputSearchCustomReport,
    vSelect,
    InputPeriodForm,
  },
  mixins: [DatepickerMixin,DeviceInfoMixin, ColorMixin],
  data() {
    return {
      popupActive: false,
      voyageStartTime: null,
      voyageEndTime: null,
      selectedStartTime: null,
      selectedEndTime: null,
      minPeriod: null,
      maxPeriod: null,
      targetDate: moment().subtract(1, 'days').toDate(),
      startTime: null,
      endTime: null,
      activeChannelOriginIndex: 0,
      activeChannelGroupIndex: -1,
      channelOriginList: [],
      channelGroupList: [],
      vesselMonitoringEngineList: [],
      vesselMonitoringEngine: {},
    }
  },
  computed: {
    ...mapGetters([
      "getMode", "getChannelOriginList", "getChannelGroupListByOrigin", "getSelectedChannelGroupId",
    ]),
    ...mapState({
      // liveDataTimeRange: state => state.liveDataTimeRange,
      selectedChannelOriginId: state => state.selectedChannelOriginId,
      engineInfo: state => state.engineInfo,
      channelOriginsMap: state => state.channelOriginsMap,
      channelGroupsMapByOrigin: state => state.channelGroupsMapByOrigin,
    }),
    displayStartTime() {
      return this.voyageStartTime ? moment(this.voyageStartTime).format("YYYY/MM/DD HH:mm") : null;
    },
    displayEndTime() {
      return this.voyageEndTime   ? moment(this.voyageEndTime  ).format("YYYY/MM/DD HH:mm") : null;
    },
    isIPhonePortrait() {
      return this.deviceType === 'iPhone' && this.getDeviceInfo().deviceOrientation === 'portrait';
    },
    reduceButton() {
      return this.$store.state.reduceButton;
    },
    activeChannelGroupName() {
      const channelGroups = this.channelGroupList.map(
        (channel) => channel.channelGroup,
      );
      const activeChannelGroup = channelGroups.find(
        (channelGroup) =>
          channelGroup.channel_group_id === this.getSelectedChannelGroupId,
      );
      return (
        activeChannelGroup &&
        (activeChannelGroup.name_loc || activeChannelGroup.name)
      );
    },
    isLiveMode() {
      return this.getMode === "live";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    windowHeight() {
      return this.$store.state.windowHeight;
    },
    isPeriodSelected() {
      if (this.isLiveMode) return true;
      if (!this.startTime) return false;
      if (!this.endTime) return false;
      return true;
    },
  },
  watch: {
    popupActive() {
      if ( this.popupActive === true ) {

        const baseElementRect = document.getElementById('engine-input-period').getBoundingClientRect(); 
        document.getElementsByClassName("monitoring-engine-popup").forEach(vsPopupElement => {
          let targetPopupElement = vsPopupElement.querySelector("div.vs-popup");
          const popupMergin = baseElementRect.width * 0.025;
          targetPopupElement.style.position = 'absolute';
          targetPopupElement.style.left = ( baseElementRect.left + popupMergin ) + 'px';
          targetPopupElement.style.top = '';
          targetPopupElement.style.width = ( baseElementRect.width - popupMergin* 2 ) + 'px';
          targetPopupElement.style.height = '';   
          
          let targetDateSelector = document.getElementsByClassName("date-selector");
          targetDateSelector[0].style.width = ( baseElementRect.width * 0.9 ) + 'px';
          
        });
      } else {
        this.minPeriod = this.startTime;
        this.maxPeriod = this.endTime;
      }
    },
    onChangeWindowSize() {
      this.onResize();
    },
    channelGroupList() {
      this.onResize();
    },
    reduceButton() {
      setTimeout(()=> {
        this.onResize();
      }, 1500);
    },
    $route() {
      this.channelOriginList = [];
      this.channelGroupList = [];
      this.initializeComponent();
    },
    // vesselMonitoringEngine() {
    //   // TODO: 必要か？
    // },
    channelOriginList() {
      this.$emit("refreshChannelOriginList");
    },
    isLiveMode() {
      this.$emit("onChangeMode");
    },
  },
  methods: {
    ...mapActions([
      "setModeState",
      "setChannelTimeFromState",
      "setChannelTimeToState",
      "initializeChannelMaster",
      "clearLocalDbChannelData",
      "initializeEngineInfo",
      "fetchVoyageHistories",
      "appendVoyageHistoryToEngineInfo",
      "setReferencedChannelIdMap",
      "setSelectedChannelOriginId",
      "setSelectedChannelGroupId",
      "initializeCustomChannelIds",
    ]),


    /**
     * ライブデータを取得.
     */
    async submitLiveMode(forceFlg) {
      if (this.getMode !== "live" || forceFlg === true) {

        this.openLoading();
        this.$nextTick(async () => {

          await this.clearLocalDbChannelData();
          await this.setReferencedChannelIdMap({});

          await this.setModeState("live");
          await this.setChannelTime("live");

          this.$emit('refreshChannelData');
          this.$vs.loading.close('#content-area > .con-vs-loading');
        });
      }
    },

    /**
     * Dateモードでデータを取得.
     */
    async submitDateMode() {

      this.openLoading();
      this.$nextTick(async () => {

        await this.clearLocalDbChannelData();
        await this.setReferencedChannelIdMap({});

        this.selectedStartTime = moment(this.startTime).local().format("YYYY/MM/DD HH:mm");
        this.selectedEndTime   = moment(this.endTime  ).local().format("YYYY/MM/DD HH:mm");
        this.popupActive = false;
        
        await this.setModeState("date");
        await this.setChannelTime("date");

        this.$emit('refreshChannelData');
        this.$vs.loading.close('#content-area > .con-vs-loading');
      });
    },

    async applyDateFromCalendar(startTime, endTime) {
      this.startTime = startTime;
      this.endTime = endTime;
      await this.submitDateMode();
    },

    /**
     * データ発生元を変更.
     */
    channelOriginClicked(id){
      this.openLoading();
      this.$nextTick(async () => {

        await this.setChannelTime(this.getMode);
        await this.setSelectedChannelOriginId(id);
        this.channelGroupList = this.getChannelGroupListByOrigin(id);
        this.activeChannelGroupIndex = this.getChannelGroupListByOrigin(id).findIndex( x => x.channelGroup.channel_group_id === this.getSelectedChannelGroupId );

        this.$emit('refreshChannelData');
        this.$vs.loading.close('#content-area > .con-vs-loading');
      });
    },


    /**
     * チャンネルグループを変更.
     */
    channelGroupClicked(channelGroup) {

      this.openLoading();
      this.$nextTick(async () => {

        await this.setChannelTime(this.getMode);
        await this.setSelectedChannelGroupId(channelGroup);

        this.$emit('refreshChannelData');
        this.$vs.loading.close('#content-area > .con-vs-loading');
      });
    },


    /**
     * モードに合わせて開始終了時間をstate保存.
     */
    async setChannelTime(mode) {
      let time_from = null;
      let time_to = null;
            // liveの時は72hour
      if (mode === "live") {
        time_from = moment()
          .subtract(60 * 24 * 3, "minutes")
          .valueOf();
        time_to   = moment().valueOf();
      } else {
        time_from = moment(this.startTime).valueOf();
        time_to   = moment(this.endTime  ).valueOf();
      }

      await this.setChannelTimeFromState(moment(time_from).toISOString());
      await this.setChannelTimeToState(  moment(time_to  ).toISOString());
    },

    refreshChannelDataFromCustom() {
      this.$emit('refreshChannelData');
    },

    /**
     *  input-period-sliderの変化を受けて、日付指定ダイアログの 開始時間--終了時間をリアクティブに表示.
     */
    getPeriod(periods) {
      this.startTime = periods.startPeriod;
      this.endTime   = periods.endPeriod;
    },

    /**
     * ローディング (最長20秒).
     */
    openLoading(){
      this.$vs.loading({
        text: "データ取得中",
        textAfter: true,
        color: this.AISEA_COLOR.BLUE,
        container: '#content-area',
      })
      setTimeout( ()=> {
        this.$vs.loading.close('#content-area > .con-vs-loading')
      }, 20000); // 最長20秒
    },


    /**
     *  航海履歴をAPI取得.
     */
    async searchVoyageHistories(vesselIds) {
      let payload = {
        vessel_ids: vesselIds,
        page: 0,
        limit: 999,
      };
      return await this.fetchVoyageHistories(payload);
    },

    /**
     *  データ発生元一覧タブにカスタムレポートを追加して返却.
     */
    getChannelOriginListForDisp() {
      let list = JSON.parse(JSON.stringify(this.getChannelOriginList));
      list = list.map((origin) =>
        origin.id === "1"
          ? {
              ...origin,
              icon: "bar_chart",
            }
          : origin,
      );
      list.push({
        id: "custom",
        name: "カスタムレポート",
        name_loc: "カスタムレポート",
        icon: "add",
      });

      this.activeChannelOriginIndex = list.findIndex(x => x.id === this.selectedChannelOriginId);
      return list;
    },

    /**
     *   リサイズに伴うエレメントサイズの明示的変更.
     */
    onResize() {
      this.$nextTick(() => {
        const routerViewElements = document.getElementsByClassName("router-view");
        const routerViewWidth = routerViewElements[0].getBoundingClientRect().width ;

        const enginCategoryItemsElement = document.getElementById("engine-category-items");
        if ( enginCategoryItemsElement ) {
          const conUlTabsElement = enginCategoryItemsElement.querySelector("ul.vs-tabs--ul");
          if ( conUlTabsElement ) {
            const bufferSize = ['iPhone', 'iPad'].includes(this.deviceType) ? '4.8rem' : '6rem';
            conUlTabsElement.style.setProperty( 'width', `calc( ${routerViewWidth}px - ${bufferSize} )` , 'important');
          }
        }
      });
    },
    /**
     *  機関データ一覧の生成.
     */
    async setVesselMonitoringEngineList() {
      // 自社有効船舶をリストで取得
      let payload = {
        is_disabled: false,
        is_deleted: false,
        page: 0,
        limit: 9999,
      };
      let res = await EnterpriseVesselApi.search(payload);
      let vesselList = res.data.vessels;

      let promiseAll = [];
      vesselList
        .filter(
          (vessel) => vessel.vessel_origins && vessel.vessel_origins.length > 0,
        )
        .forEach((vessel) => {
          promiseAll.push(
            (async () => {
              const vesselMonitoringEngine = vessel;
              vesselMonitoringEngine.selectedHistoryYear = null;

              // 期間データ取得元を取得
              try {
                const res = await epVesselDisplayChannelApi.getChannelOrigins(
                  vesselMonitoringEngine.enterprise_vessel_id,
                );
                vesselMonitoringEngine.channelOrigins = res.data.channel_origins
                  .slice()
                  .sort((a, b) => a.sort_order - b.sort_order);
              } catch {
                vesselMonitoringEngine.channelOrigins = [];
              } finally {
                vesselMonitoringEngine.channelOriginsDisp =
                  vesselMonitoringEngine.channelOrigins
                    .map((origin) => origin.name_loc || origin.name)
                    .join(", ");
              }

              return vesselMonitoringEngine;
            })(),
          );
        });
      let resultList = await Promise.all(promiseAll);

      // 取得元がない場合はリストに使用しない
      resultList = resultList.filter(
        (vesselMonitoringEngine) =>
          vesselMonitoringEngine.channelOrigins &&
          vesselMonitoringEngine.channelOrigins.length > 0,
      );
      this.vesselMonitoringEngineList = resultList;
    },
    async handleChangeVesselName(enterpriseVesselId) {
      if (
        enterpriseVesselId === this.vesselMonitoringEngine.enterprise_vessel_id
      ) {
        return;
      }

      this.vesselMonitoringEngine = cloneDeep(
        this.vesselMonitoringEngineList.find(
          (x) => x.enterprise_vessel_id === enterpriseVesselId,
        ),
      );

      this.goToDataReport(enterpriseVesselId);
    },
    async goToDataReport(enterpriseVesselId) {
      this.$router.push(
        {
          name: "addon-eco-ship-vessel-monitoring-engine",
          params: {
            id: enterpriseVesselId,
            vesselMonitoringEngineList: this.vesselMonitoringEngineList,
          },
        },
      );
    },
    async initializeComponent() {
      this.channelOriginList = [];
      this.channelGroupList = [];

      await this.clearLocalDbChannelData();
      await this.setReferencedChannelIdMap({});

      const enterpriseVesselId = this.$route.params.id;
      await this.initializeEngineInfo(enterpriseVesselId);

      if (!this.$route.params.vesselMonitoringEngineList) {
        await this.setVesselMonitoringEngineList();
      } else {
        this.vesselMonitoringEngineList =
          this.$route.params.vesselMonitoringEngineList;
      }

      if (Object.keys(this.vesselMonitoringEngine).length == 0) {
        const vesselMonitoringEngine = this.vesselMonitoringEngineList.find(
          (engine) => engine.enterprise_vessel_id === enterpriseVesselId,
        );
        this.vesselMonitoringEngine = vesselMonitoringEngine
          ? cloneDeep(vesselMonitoringEngine)
          : {};
      }

      // 画面初期化時・船舶名変更時にカスタムチャンネルを取得
      await this.initializeCustomChannelIds();
      // チャンネル一覧情報を初期化
      // この中で、channel情報が決まってしまっている
      await this.initializeChannelMaster();

      let originList = this.getChannelOriginList;
      if (originList.length === 0) {
        return;
      }

      // URL引数によるタブ初期表示の設定
      if (this.$route.query.channelOrigin) {
        const channelOrigin =
          this.channelOriginsMap[this.$route.query.channelOrigin];
        const channelOriginId = channelOrigin
          ? channelOrigin.origin_number
          : this.$route.query.channelOrigin === "custom"
          ? "custom"
          : null;
        if (channelOriginId) {
          await this.setSelectedChannelOriginId(channelOriginId);
          if (channelOriginId !== "custom" && this.$route.query.channelGroup) {
            const groupInfo =
              this.channelGroupsMapByOrigin[channelOriginId][
                this.$route.query.channelGroup
              ];
            if (groupInfo) {
              await this.setSelectedChannelGroupId(
                groupInfo.channelGroup.channel_group_id,
              );
            }
          }
        }
      }

      const channelOriginList = this.getChannelOriginListForDisp();
      this.activeChannelOriginIndex = channelOriginList.findIndex(
        (x) => x.id === this.selectedChannelOriginId,
      );

      const channelGroupList = this.getChannelGroupListByOrigin(
        this.selectedChannelOriginId,
      );
      if (channelGroupList && channelGroupList.length > 0) {
        this.activeChannelGroupIndex = channelGroupList.findIndex(
          (x) =>
            x.channelGroup.channel_group_id === this.getSelectedChannelGroupId,
        );
      }

      if (this.isLiveMode || !this.isPeriodSelected) {
        await this.submitLiveMode(true);
      } else {
        await this.submitDateMode();
      }

      this.$nextTick(() => {
        setTimeout(() => {
          this.channelOriginList = channelOriginList;
          this.channelGroupList = channelGroupList;
        }, 2000);
      });
    },
    async handleClickLiveMode() {
      if (this.isLiveMode) return;
      this.mode = "live";
      await this.submitLiveMode(true);
    },
    async handleClickDateMode() {
      if (!this.isLiveMode) return;
      await this.setModeState("date");
    },
  },

  async created() {
    this.initializeComponent();
  },
  beforeDestroy() {
    // localDbのchannelDataをクリア
    this.clearLocalDbChannelData();
    this.setReferencedChannelIdMap({});
    this.channelOriginList = [];
    this.channelGroupList = [];
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

.title-loading {
  color: rgba($aisea-gray, 0.4);
  font-size: 30px;
}

#vessel-monitoring-engine {
  background-color: $aisea-pure-white;
  border-radius: 6px;
}

.engine-input-period-origin-items-wrapper {
  border-bottom: solid 1px #e2e2e2;
  height: 98px;
  @media screen and (min-width: $max-width-iphone-8) {
    height: 50px;
  }
}
#engine-input-period {
  background-color: $aisea-pure-white;
  padding: 0;
  color: $aisea-dark-blue;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 49px;
  width: 100%;
  border-top-left-radius: 6px;
  @media screen and (min-width: $max-width-iphone-8) {
    max-width: 270px;
  }
  .selected {
    background: $aisea-blue !important;
    color: $aisea-white !important;
  }

  .condition-header-row {
    width: 100%;
    height: 100%;
    .condition-header-col-title {
      width: 100%;
    }
    .condition-header-col-period {
      width: calc( 100% - 220px ) !important;
      min-width: 400px;
    }
    .vessel-name-select-box {
      width: 100%;
    }
    .vs__dropdown-option {
      font-weight: 400;
      font-family: $aisea-font-family;
    }
  }

  .title-text {
    padding: 0.2rem 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .period-info {
    width: 560px;
    padding: 0; 
  }

  .calendar-icon {
    margin-right:0.2rem;
  }

  .mode-select-area {
    width: 160px;
    padding: 0;
    margin-left: 0.4rem;
  }

  .mode-select-button {
    padding: 4px 16px !important; 
    margin-right: 10px;
    border-radius: 4px;
    width: 160px;
  }

  .vs-button--text {
    display: flex !important;
    justify-content: center;
  }

  .vs-popup--background {
      width: 100%;
      background: rgba($aisea-black,.4);
      position: absolute;
      top: 0;
      height: 100%;
      z-index: 10;
      -webkit-transition: all .25s ease;
      transition: all .25s ease;
      opacity: 1;
  }

  .vs-popup {
      transition: all .2s;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      z-index: 20000;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 1;
  }

  .vs-popup--close {
    background-color: $aisea-white !important;
    transform: translate(-10px,10px);
    &:hover {
      transform: translate(-10px,8px);
    }
  }

  .vs-popup-container {
    z-index: 11;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .vessel-name-select-box {
    margin: 0.4rem 0 0.4rem 0;
    margin: 0;
    height: 100%;
    .vs__dropdown-toggle {
      border: none;
      height: 100%;
      padding: 0;
    }
    .vs__selected {
      color: #333333;
      max-width: 235px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-flex;
      font-family: $aisea-font-family;
      margin-top: 0;
      margin-left: 0;
      padding-left: 14px;
      height: 100%;
      border: none;
    }
    .vs__search {
      font-size: 16px; // iphoneでクリック時にズームしないようにする
      border: none;
    }
    .vs__dropdown-menu {
      border: none;
    }
  }
}

.monitoring-engine-popup {
  .vs-popup--close {
    background-color: $aisea-white !important;
    transform: translate(-10px,10px);
    &:hover {
      transform: translate(-10px,8px);
    }
  }
}

.date-selector {
  height: 16rem;
  border-radius: 6px;
  background:$aisea-white;
  padding: 15px;
  margin-left: auto;
  margin-right: auto;

  .date-picker {
    width: 140px;
    display: inline-block;
  }

  .vs-button {
    padding: 4px 18px !important;
  }

  .time-range-text {
    margin-bottom: 20px;
  }

  .get-data-button {
    width: 10rem; 
    margin: 0.4rem;
  }
}


#engine-origin-items {
  background-color: $aisea-pure-white;
  overflow: hidden;
  height: 50px;
  .ul-tabs {
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
  }
  .vs-tabs--li {
    .vs-tabs--btn {
      min-height: 3rem;
      color: $aisea-blue-gray; // 文字色
      height: 50px;
      padding: 18px 14px;
      border-bottom: solid 1px #e2e2e2;
      border-left: solid 1px #e2e2e2;
      &:hover {
        background-color: rgba($aisea-blue, 0.1);
      }
      line-height: 21px;
      span {
        vertical-align: sub;
        font-family: $aisea-font-family;
        font-weight: 400;
      }
    }
    &:first-child {
      .vs-tabs--btn {
        border-left: none;
        @media screen and (min-width: $max-width-iphone-8) {
          border-left: solid 1px #e2e2e2;
        }
      }
    }
    &:not(:first-child):not(:last-child) {
      .vs-tabs--btn {
        border-left: solid 1px #e2e2e2;
      }
    }
    &:last-child {
      .vs-tabs--btn {
        @media screen and (min-width: $max-width-iphone-8) {
          border-right: solid 1px #e2e2e2;
        }
      }
    }
  }
  .activeChild button.vs-tabs--btn {
    border-top: 3px solid #039be5 !important; // 選択時の背景色
    border-radius: 0;
    color: $aisea-blue;
    background-color: rgba($aisea-blue, 0.1);
    height: 49px;
    border-bottom: none;
    span {
      font-weight: 600;
    }
  }
  .vs-tabs--content {
    padding: 0;
  }
  .con-slot-tabs {
    div {
      transition: unset;
    }
  }
}

.engine-category-voyage-period-wrapper {
  padding: 1px 16px;
  justify-content: center;
  @media screen and (min-width: 667px) {
    justify-content: space-between;
  }
  .voyage-period {
    --vs-line-height: 2;
    width: 100%;
    @media screen and (orientation: portrait) {
      margin-left: 0px;
    }
    @media screen and (min-width: 667px) {
      width: fit-content;
    }
    .period-body {
      width: 100%;
    }
    .last-updated-at-wrapper {
      .last-updated-at {
        background: #f2f2f2;
        border-radius: 20px;
        padding: 2px 7px;
        width: 100%;
        justify-content: center;
      }
      @media screen and (min-width: 667px) {
        justify-content: space-between;
        max-width: 248px;
      }
    }
  }
}
#engine-category-items {
  color: $aisea-white;
  display: flex;
  align-items: center;
  min-width: 310px;
  width: 100%;
  margin-top: 20px;
  @media screen and (min-width: 667px) {
    max-width: 340px;
  }

  .vs-tabs--btn {
    margin-top: 1rem;
    min-height: 2rem;
    min-width: 10rem;
    color: $aisea-white; // 文字色
    border-radius: 5px 5px 0px 0px;
    padding-left: 1.2rem;
    padding-right: 1.2rem;
    :hover {
      color: $aisea-white !important; // ホバーの文字色
    }
  }
  .activeChild button.vs-tabs--btn {
    background-color: $aisea-white !important;
    padding-top: 0.8rem;
    span {
      color: $aisea-blue-gray !important; // 選択時の文字色
    }
  }
  .vs-tabs--content {
    padding: 0;
  }
  .line-vs-tabs {
    height: 0 !important;
    width: 0 !important;
    border: 0 !important;
    background: $aisea-blue-gray;
  }
  .vs-tabs--ul {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;

    &::-webkit-scrollbar {
      height: 0.6rem;
    }
    &::-webkit-scrollbar-track {
      background: $aisea-blue-gray;
    }
    &::-webkit-scrollbar-thumb {
      background: $aisea-gray;
      border-radius: 0.4rem;
    }

  }
  .con-slot-tabs {
    div {
      transition: unset;
    }
  }
  .line-vs-tabs {
    border: 1px solid $aisea-white;
  }
  .line-vs-tabs {
    border: 1px solid $aisea-white;
  }
  .category-select-box-wrapper {
    width: 100%;
    .category-select-box {
      .vs__selected {
        color: #333333;
        font-family: $aisea-font-family;
      }
      .vs__search {
        font-size: 16px; // iphoneでクリック時にズームしないようにする
      }
    }
    --vs-line-height: 2;
  }
  .engine-data-custom-report {
    .channel-incremental-search {
      input {
        background: $aisea-pure-white !important;
      }
    }
  }
}

#select-display-mode {
  display: none;
  @media screen and (min-width: 768px) and (min-height: 376px) {
    display: flex;
  }
  .list-type-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    border-radius: 15px;

    font-family: $aisea-font-family;
    font-size: 14px;

    &.live {
      width: 123px;
    }
    &.date {
      width: 120px;
    }

    &--selected {
      border: 1px solid $aisea-blue;
      background-color: $aisea-blue;
      color: $aisea-pure-white;
      font-weight: 600;
      cursor: default;
    }
    &--default {
      border: 1px solid $aisea-light-gray;
      background-color: none;
      color: none;
      font-weight: 400;
      &:hover {
        color: $aisea-blue;
        border-color: $aisea-blue;
      }
    }
  }
}

.channel-group-tabs {
  &--narrow {
  .vs-tabs--ul {
    width: calc(100vw - 6rem - 260px);
  }

  }
  &--wide {
  .vs-tabs--ul {
    width: calc(100vw - 6rem);
  }

  }
}

.channel-group-area {
  width: 100%;
  .categories-area {
    display: flex;
    width: 100%;
    align-items: center;
  }
}

.category-item {
  height: 54px;
  font-size: 16px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
